import PredefineLabels from 'v3/common/components/DatePicker/DateRange/PredefinedLabels';
import { DateRange } from 'v3/common/components/DatePicker/DateRange/type';
import { useCalendar } from 'v3/common/components/DatePicker/DateRange/useCalendar';
import RenderDatePicker from 'v3/common/components/DatePicker/DateRange/RenderDatePicker';

type CalendarProps = DateRange & {
  isShowCustom: boolean;
  setIsShowCustom: (show: boolean) => void;
  onCloseRightContent: () => void;
  setIsComponentVisible: (visible: boolean) => void;
  setLabelIndex: (index: number | null) => void;
  labelIndex: number | null;
};

const Calendar = ({
  startDate,
  endDate,
  isShowCustom,
  setIsShowCustom,
  onCloseRightContent,
  setLabelIndex,
  setIsComponentVisible,
  labelIndex,
}: CalendarProps) => {
  const {
    start,
    end,
    ranges,
    onApply,
    calendarStartDate,
    calendarEndDate,
    handleDateChange,
    onCloseCalendar,
  } = useCalendar({
    startDate,
    endDate,
    setIsComponentVisible,
    onCloseRightContent,
  });

  return (
    <div className="calendar-container">
      <div className="custom-label-container">
        <PredefineLabels
          index={labelIndex}
          setLabelIndex={setLabelIndex}
          ranges={ranges}
          setIsShowCustom={setIsShowCustom}
          onCloseCalendar={onCloseCalendar}
        />
      </div>

      {isShowCustom && (
        <div className="date-picker-container row">
          <RenderDatePicker
            type="start"
            label="Start Date"
            start={start}
            end={end}
            handleDateChange={handleDateChange}
            calendarStartDate={calendarStartDate}
            calendarEndDate={calendarEndDate}
            selectedDate={start}
          />
          <RenderDatePicker
            type="end"
            label="End Date"
            start={start}
            end={end}
            handleDateChange={handleDateChange}
            calendarStartDate={calendarStartDate}
            calendarEndDate={calendarEndDate}
            selectedDate={end}
          />
          <div className="d-flex gap-2 justify-content-end align-items-end mt-3">
            <button onClick={() => setIsComponentVisible(false)} className="btn  btn-outline-secondary mt-4">
              Cancel
            </button>
            <button onClick={onApply} className="btn btn-primary mt-4">
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Calendar;
